/* A and B's handles — `SelectionMarkers.tsx`. Moved unchanged out of
 * `pages/client-detail/ui/TwoDates.module.css` with the component, 28 September 2026. */

/* A full-bleed box the two handles position inside, so a handle's coordinates are the plot's own.
 * It passes the pointer through; only the handles themselves take it. */
.markerLayer {
  position: absolute;
  inset: var(--space-0);
  pointer-events: none;
}

/* One handle: the chip, the stem under it and the ring on the reading. `translateX(-50%)` centres
 * the whole column on the instant it names, so the stem stands exactly on the date. */
.marker {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: var(--w-two-dates-grip);
  margin-inline-start: calc(var(--w-two-dates-grip) / -2);
  cursor: ew-resize;
  pointer-events: auto;
  touch-action: none;
}

.marker:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

/* The canon's grip: a 24x20 ROUNDED RECTANGLE, not a round badge. The shape matters — a circle
 * reads as a point on the line, and this is a handle that stands above the plot and owns a date. */
.markerChip {
  display: grid;
  flex: none;
  place-items: center;
  width: var(--w-two-dates-grip);
  height: var(--h-two-dates-grip);
  margin-block-end: var(--h-two-dates-grip-gap);
  font-size: var(--fs-micro);
  font-weight: var(--fw-extrabold);
  line-height: var(--lh-auto);
  color: var(--on-accent-grad);
  background: var(--primary-fill);
  border-radius: var(--radius-xs);
}

.markerStem {
  flex: 1;
  width: var(--border-thick);
  background: var(--accent);
}

/* The reading the marker stands on, ringed the way every other mark on this plot is: the card's own
 * fill inside the accent, so the line passes behind it rather than through it. */
.markerDot {
  position: absolute;
  width: var(--w-two-dates-grip-dot);
  height: var(--w-two-dates-grip-dot);
  background: var(--bg-card);
  border-width: var(--border-grip-ring);
  border-style: solid;
  border-color: var(--accent);
  border-radius: var(--r-pill);
  transform: translateY(-50%);
}
